import React from "react";
import { observer } from "mobx-react";
import ColorsStore from "../stores/ColorsStore";
import classNames from "classnames";
import ImgLazyLoad from "./ImgLazyLoad";

interface ImageContainerProps {
  colorsStore: ColorsStore;
  imgSrc: any;
  colorText: string;
}

const ImageContainer = observer((props: ImageContainerProps) => {
  const { colorsStore, colorText } = props;
  const navBackClass = classNames({
    "customise-car__colors__control": true,
    "customise-car__colors__control--prev": true,
    "customise-car__colors__control--disabled":
      colorsStore.getNavigationState("Back"),
  });
  const navNextClass = classNames({
    "customise-car__colors__control": true,
    "customise-car__colors__control--next": true,
    "customise-car__colors__control--disabled":
      colorsStore.getNavigationState("Next"),
  });

  console.log(
    `Window.innerwidth: ${window.innerWidth}, is mobile: ${colorsStore.breakpoint.isTinyMobile}`
  );
  // var cardWidth = window.innerWidth > 769 ? 650 : window.innerWidth * 0.9;
  var cardWidth = colorsStore.breakpoint.isTinyMobile
    ? window.innerWidth * 0.9
    : 650;

  return (
    <div style={{ position: "relative" }}>
      <div
        className={navBackClass}
        onClick={() => {
          colorsStore.navigateToImage("Back");
        }}
      >
        Back
      </div>
      <div
        className="nav-window"
        style={{
          width: `${cardWidth * colorsStore.colorOption.colourImages.length}px`,
          height: "100%",
          transform: `translateX(${colorsStore.navPosition}%)`,
        }}
      >
        {colorsStore.colorOption.colourImages.map((image, index) => {
          const imageShowClass = classNames({
            "image-clip": true,
          });

          return (
            <div key={index} className={imageShowClass}>
              <ImgLazyLoad
                style={{ maxWidth: `${cardWidth}px` }}
                key={index}
                src={image}
                alt={`colorText${index}`}
              />
            </div>
          );
        })}
      </div>
      <div
        className={navNextClass}
        onClick={() => {
          colorsStore.navigateToImage("Next");
        }}
      >
        Next
      </div>
    </div>
  );
});

export default ImageContainer;
